function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from 'react';
import styled, { css } from 'styled-components';
import cl from 'classnames';
import { neutral } from '../Color';
import convertSizeToPx from '../utils/convertSizeToPx';
import getPrimaryCss from './getPrimaryCss';
import getOutlineCss from './getOutlineCss';
import getDashedCss from './getDashedCss';
import getDangerCss from './getDangerCss';
import getWarningCss from './getWarningCss';
import getSuccessCss from './getSuccessCss';
import getInfoCss from './getInfoCss';
import getSecondaryCss from './getSecondaryCss';
import getTertiaryCss from './getTertiaryCss';
import getLinkCss from './getLinkCss';
import getPureLinkCss from './getPureLinkCss';
import getDarkCss from './getDarkCss';
import getIconSizeByType from './getIconSizeByType';
import UniversalLink from './UniversalLink';
import { borderWidth, borderRadius } from '../core';
const getSize = function () {
  let size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
  switch (size) {
    case 'small':
      return css(["height:24px;line-height:20px;font-size:14px;"]);
    case 'large':
      return css(["height:42px;line-height:38px;font-size:16px;"]);
    default:
      break;
  }
  return css(["height:32px;line-height:28px;font-size:14px;"]);
};
const getRoundCss = size => {
  const sizeInPx = convertSizeToPx(size);
  return css(["width:", "px;height:", "px;border-radius:100%;padding:0;"], sizeInPx, sizeInPx);
};
const getNoBorderCss = () => {
  return css(["border-color:transparent;background-color:transparent;"]);
};
const full = css(["width:100%;"]);
const StyledButton = styled(UniversalLink).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-2t1x3o-0"
})(["display:inline-block;outline:none;cursor:pointer;user-select:none;padding-left:1em;padding-right:1em;border-width:", "px;border-radius:", "px;border-style:solid;border-color:white;background-color:white;color:", ";text-decoration:none;margin-bottom:", ";min-width:", ";text-align:", ";", ";& > svg{margin-left:auto;margin-right:auto;}&:disabled,&.disabled{pointer-events:none;}.icon,.iconLeft,.iconRight{display:inline-block;vertical-align:middle;& > svg{display:block;}}.iconLeft{margin-right:4px;}.iconRight{margin-left:4px;}", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";"], borderWidth, borderRadius, neutral.color1, _ref2 => {
  let {
    marginBottom = '0.5em'
  } = _ref2;
  return marginBottom;
}, _ref3 => {
  let {
    minWidth = 'auto'
  } = _ref3;
  return minWidth;
}, _ref4 => {
  let {
    textAlign = 'center'
  } = _ref4;
  return textAlign;
}, props => !props.longBtn ? 'white-space: nowrap' : '', props => getSize(props.size), props => props.type === 'primary' ? getPrimaryCss() : '', props => props.type === 'outline' ? getOutlineCss() : '', props => props.type === 'dashed' ? getDashedCss() : '', props => props.type === 'danger' ? getDangerCss() : '', props => props.type === 'warning' ? getWarningCss() : '', props => props.type === 'success' ? getSuccessCss() : '', props => props.type === 'info' ? getInfoCss() : '', props => props.type === 'tertiary' ? getTertiaryCss() : '', props => props.type === 'rdd' ? getTertiaryCss() : '', props => props.type === 'secondary' ? getSecondaryCss() : '', props => props.type === 'link' ? getLinkCss() : '', props => props.type === 'purelink' ? getPureLinkCss() : '', props => props.type === 'dark' ? getDarkCss() : '', props => props.full ? full : '', props => props.round ? getRoundCss(props.size) : '', props => props.noBorder ? getNoBorderCss() : '', props => props.noMargin ? css(["margin-bottom:0;"]) : '', props => props.spaceLeft ? css(["margin-left:1em;"]) : '', props => props.spaceRight ? css(["margin-right:1em;"]) : '');
const Button = _ref => {
  let {
      type = 'primary',
      size = 'default',
      full = false,
      round = false,
      noBorder = false,
      noMargin = false,
      spaceLeft = false,
      spaceRight = false,
      IconLeft,
      IconRight,
      children,
      disabled,
      className
    } = _ref,
    props = _objectWithoutProperties(_ref, ["type", "size", "full", "round", "noBorder", "noMargin", "spaceLeft", "spaceRight", "IconLeft", "IconRight", "children", "disabled", "className"]);
  return React.createElement(StyledButton, _extends({}, props, {
    type: type,
    size: size,
    full: full,
    round: round,
    noBorder: noBorder,
    noMargin: noMargin,
    spaceLeft: spaceLeft,
    spaceRight: spaceRight,
    disabled: disabled,
    className: cl({
      disabled
    }, className)
  }), IconLeft && React.createElement("span", {
    className: "iconLeft"
  }, React.createElement(IconLeft, {
    size: getIconSizeByType(size)
  })), children, IconRight && React.createElement("span", {
    className: "iconRight"
  }, React.createElement(IconRight, {
    size: getIconSizeByType(size)
  })));
};
export default Button;